<template>
  <div class="home">
    <!-- PC/手机 通用 -->
    <home-nav></home-nav>
    
    <!-- banner -->
    <home-banner></home-banner>
    <!-- <phone-banner></phone-banner> -->
    <!-- banner-END -->
    
    <!-- PC/手机 通用 -->
    <home-news></home-news>

    <!-- effect -->
    <home-effect></home-effect>
    <phone-effect></phone-effect>
    <!-- effect-END -->

    <!-- capability -->
    <phone-capability></phone-capability>
    <home-capability></home-capability>
    <!-- capability-END -->
    
    <!-- solution -->
    <home-solution></home-solution>
    <phone-solution></phone-solution>
    <!-- solution-END -->

    <!-- PC/手机 通用 -->
    <home-step></home-step>

    <!-- footer -->
    <home-footer></home-footer>
    <phone-footer></phone-footer>
    <!-- footer-END -->
  </div>
</template>

<script>

import HomeNav from '../common/Nav.vue';
import HomeBanner from './components/Banner.vue';
// import PhoneBanner from './components/PhoneBanner.vue';
import HomeNews from './components/News.vue';
import HomeEffect from './components/Effect.vue';
import PhoneEffect from './components/PhoneEffect.vue';
import HomeCapability from './components/Capability.vue';
import PhoneCapability from './components/PhoneCapability.vue';
import HomeSolution from './components/Solution.vue';
import PhoneSolution from './components/PhoneSolution.vue';
import HomeStep from './components/Step.vue';
import HomeFooter from '../common/Footer.vue';
import PhoneFooter from '../common/PhoneFooter.vue';

export default {
  name: 'Home',
  props: {
  },
  components: {
    HomeNav,
    HomeBanner,
    // PhoneBanner,
    HomeNews,
    HomeEffect,
    PhoneEffect,
    HomeCapability,
    PhoneCapability,
    HomeSolution,
    PhoneSolution,
    HomeStep,
    HomeFooter,
    PhoneFooter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

</style>
